var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Vlt-steps"},_vm._l((_vm.items),function(step,index){return (_vm.items.length)?_c('div',{key:index,staticClass:"Vlt-steps__item",class:_vm.getClassObject(step, index),attrs:{"id":_vm.id},on:{"click":function($event){return _vm.select(step, index)}}},[_vm._v("\n    "+_vm._s(step.title)+"\n  ")]):_vm._e()}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }